(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notice-banner"] && !Shopify.designMode) return;
  try {
    
  class NoticeBanner extends HTMLElement {
    connectedCallback() {
      this.storageKey = this.dataset.storageKey;

      // In the theme editor always show the banner so it stays editable.
      const inEditor = window.Shopify && window.Shopify.designMode;

      if (!inEditor && this.storageKey) {
        try {
          if (sessionStorage.getItem(this.storageKey) === 'dismissed') {
            this.classList.add('notice-banner--dismissed');
            return;
          }
        } catch (e) {
          /* sessionStorage unavailable (private mode) — just show the banner. */
        }
      }

      const closeButton = this.querySelector('.notice-banner__close');
      if (closeButton) {
        closeButton.addEventListener('click', this.dismiss.bind(this));
      }
    }

    dismiss(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      this.classList.add('notice-banner--dismissed');
      if (this.storageKey) {
        try {
          sessionStorage.setItem(this.storageKey, 'dismissed');
        } catch (e) {
          /* Ignore storage failures — dismissal just won't persist. */
        }
      }
    }
  }

  if (!customElements.get('notice-banner')) {
    customElements.define('notice-banner', NoticeBanner);
  }

  } catch(e) { console.error(e); }
})();
})();
